import { nightModes } from "@/mocks/comicGuide";

export default function NightMode() {
  return (
    <section id="night" className="bg-background-950 py-14 text-background-50 md:py-20">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 items-center gap-10 px-4 lg:grid-cols-2 md:px-6">
        <div className="order-2 lg:order-1">
          <img
            src="https://readdy.ai/api/search-image?query=dark%20cozy%20stylized%20illustration%20of%20reading%20comics%20on%20a%20phone%20at%20night%20in%20bed%2C%20warm%20dim%20moonlight%2C%20deep%20charcoal%20and%20soft%20amber%20glow%2C%20blanket%20and%20pillow%2C%20playful%20editorial%20artwork%2C%20calm%20atmosphere%2C%20high%20detail&width=900&height=1100&seq=comic-night-mode&orientation=portrait"
            alt="深夜躺在床上用手机阅读漫画的深色插画"
            className="h-72 w-full rounded-2xl object-cover object-top lg:h-80"
          />
        </div>

        <div className="order-1 lg:order-2">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-800 px-4 py-1.5 text-sm font-medium text-background-100">
            <i className="ri-moon-clear-line text-secondary-300"></i> 夜间模式
          </span>
          <h2 className="mt-4 font-heading text-3xl text-background-50 md:text-4xl">深夜追漫，也要护眼又好看</h2>
          <p className="mt-4 text-base leading-relaxed text-background-300">
            夜间模式不只是把页面变暗。针对漫画阅读优化过的夜间模式，能在保护视力的同时保留画面细节，让通宵追更也成为一种享受。
          </p>

          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
            {nightModes.map((m) => (
              <div key={m.title} className="rounded-2xl border border-background-800 bg-background-900 p-5">
                <h3 className="flex items-center gap-2 text-base font-bold text-background-50">
                  <i className="ri-checkbox-circle-line text-accent-400"></i> {m.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-background-300">{m.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}